import React from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
/* import Select from '@material-ui/core/Select'; */
import { KeyboardDatePicker } from "@material-ui/pickers";
import Select from "react-select";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import food9 from "./../../../../images/foods/food9.png";
import food10 from "./../../../../images/foods/food10.png";
import {
  Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
} from "react-bootstrap";

const FoodMenuForm = ({
  PopupCommonStateTransfer,
  isView,
  ArrayPopupCommonStateTransfer,
  handleChange,
  errors,
  onChangeCommonpopup,
  variant,
}) => (
  <div className="row">
    <div className="col-sm-6 col-md-4 col-xl-4">
      <FormGroup>
        <Label for="itemname">
          Variant Type<span class="text-danger">*</span>
        </Label>
        <Select
          options={variant}
          name="itemname"
          id="itemname"
          placeholder="Enter Item Name"
          maxLength="40"
          required
          autoComplete="off"
        />
      </FormGroup>
    </div>
    

   {/*  <div className="col-sm-6 col-md-4 col-xl-4">
      <FormGroup>
        <Label for="itemprice">
          Item price<span class="text-danger">*</span>
        </Label>
        <Input
          type="numbers"
          name="itemprice"
          id="itemprice"
          placeholder="Enter Item price"
          value="RS.60"
          maxLength="4"
          required
          autoComplete="off"
        />
      </FormGroup>
    </div> */}

    {/* <div className="col-sm-6 col-md-4 col-xl-4">
      <Label for="veg">Item Type</Label>

      <FormGroup>
        <Input type="radio" name="veg" id="veg" defaultChecked />
        <Label className="ml-5" for="veg">Veg</Label>
        <img className="ml-5 mr-20" src={food9} width="5%" height="5%"></img>
       
        <Input type="radio" name="veg" id="nonveg" />
        <Label className="ml-5" for="nonveg">Non-Veg</Label>
        <img className="ml-5" src={food10} width="5%" height="5%"></img>
       
      </FormGroup>
    </div> */}
  </div>
);
export default FoodMenuForm;
